import component from './promocode.component';

export default angular
  .module('fizyweb.paycell.promocode', [])
  .component('fizyPaycellPromocode', component).name;



// WEBPACK FOOTER //
// src/app/components/promocode/promocode.module.ts